﻿(() => {
    angular.module('fliptoWeb')
        .factory('server', ['$http', function ($http) {
        ///<summary>Server service for angular poststay application</summary>

        return {
            call: function (method, url, data, isAsync) {
                /// <summary>makes an ajax call to the server</summary>
                /// <returns>promise</returns

                return $http({
                    url: url,
                    method: method,
                    headers: {
                        contentType: 'application/json;',
                    },
                    data: data,
                });
            }
        };
    }]);
})()


///// <reference path="../_references.ts" />
///// <reference path="../application.ts" />

//module FliptoWeb.Services {

//    export interface IServerService {
//        call(method: string, url: string, data: Object, isAsync: boolean);
//    }

//    export class ServerService {

//        http: ng.IHttpService;

//        constructor($http: ng.IHttpService) {
//            this.http = $http;
//        }

//        call(method: string, url: string, data: Object, isAsync: boolean) {
//            return this.http({
//                url: url,
//                method: method,
//                headers: {
//                    contentType: 'application/json;',
//                },
//                data: data,
//            });
//        }
//    }
//}